<template>
  <div class="yearList">
    <div class="yearBanner">
      <div class="config">
        <router-link to="/" class="logo" target="_blank"
          ><img src="/static/year/Landingpage_MANA_head_logo@2x.png" alt=""
        /></router-link>

        <el-popover placement="bottom" width="240px" trigger="hover">
          <share :config="config"></share>
          <span class="configBox" slot="reference">
            <img src="/static/year/landingpage_share_icon@2x.png" alt="" /><span
              class="text"
              >{{ $t("global.分享") }}</span
            >
          </span>
        </el-popover>
      </div>
    </div>
    <div class="imgList">
      <div
        class="imgBox"
        v-for="(item, i) in imgList"
        :key="i"
        :style="{ backgroundImage: `url(${item.imgurl})` }"
        @mouseenter="index = i"
        @mouseleave="index = null"
        @click="goto(item.url)"
      >
        <div class="butBox" :class="{ active: index == i }">
          <span class="tes">{{ $t("works.点击查看") }}</span
          ><img
            :src="
              index == i
                ? '/static/year/arrow_black@2x.png'
                : '/static/year/arrow_white@2x.png'
            "
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Share from "@/components/v2/Share";
export default {
  name: "yearList2020",
  metaInfo() {
    return {
      title: this.$t('works.2020MANA年度全球精选作品盘点') + " | MANA",
    };
  },
  data() {
    return {
      config: {},
      index: null,
      imgList: [
        {
          imgurl: "https://image.manamana.net/1612510616000_VIciCxFG",
          url: "/playlist/53709",
        },
        {
          imgurl: "https://image.manamana.net/1612510651000_TPORfebv",
          url: "/playlist/53710",
        },
        {
          imgurl: "https://image.manamana.net/1612510665000_gxrGmIKm",
          url: "/playlist/53659",
        },
        {
          imgurl: "https://image.manamana.net/1612510679000_gwvneuCR",
          url: "/playlist/53708",
        },
        {
          imgurl: "https://image.manamana.net/1612765561000_lundefinedSOzpDz",
          url: "/playlist/53712",
        },
        {
          imgurl: "https://image.manamana.net/1612765707000_YRaRdKVU",
          url: "/playlist/53711",
        },
        {
          imgurl: "https://image.manamana.net/1612766244000_WEbwGKFQ",
          url: "/playlist/53697",
        },
        {
          imgurl: "https://image.manamana.net/1612513472000_sBcFrZUL",
          url: "/playlist/53705",
        },
      ],
    };
  },
  created() {
    this.config = {
      share_url: location.href,
      title: this.$t('works.2020MANA年度全球精选作品盘点'),
      desc: "",
      pics: "https://image.manamana.net/1612514263000_LADPLTlo",
    };
  },
  components: {
    Share,
  },
  methods: {
    goto(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="stylus" scoped>
.yearList {
  background: url('https://image.manamana.net/1612510190000_TntmHsgW');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-width: 918px;
  min-height: 100vh;
  .yearBanner {
    background: url('https://image.manamana.net/1612510286000_cqlFonPW');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: 350px;

    .config {
      padding: 10px 48px 0;

      .logo {
        display: inline-block;
        width: 120px;
        height: 50px;
        vertical-align: middle;
        margin-right: 28px;
        cursor: pointer;

        img {
          width: 120px;
          height: 50px;
        }
      }

      .configBox {
        display: inline-block;
        vertical-align: middle;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        cursor: pointer;

        img {
          width: 40px;
          height: 40px;
        }

        .text {
          vertical-align: middle;
          margin-left: 4px;
        }
      }
    }
  }

  .imgList {
    width: 918px;
    margin: 0 auto;
    padding: 10px 0 120px 0;

    .imgBox {
      width: 100%;
      height: 270px;
      margin-bottom: 60px;
      background-size: 100%;
      position: relative;
      cursor: pointer;
      .butBox {
        padding: 0 20px 0 36px;
        height: 40px;
        background: rgba(10, 10, 10, 0.4);
        line-height: 40px;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        position: absolute;
        bottom: 67px;

        .tes {
          margin-left: 4px;
        }

        img {
          width: 28px;
          height: 28px;
          vertical-align: middle;
          margin-bottom: 4px;
        }
      }

      .active {
        background: #fff;
        color: #0A0A0A;
      }

      &:nth-child(2n) {
        .butBox {
          right: 205px;
        }
      }

      &:nth-child(2n+1) {
        .butBox {
          left: 205px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/yearList/yearList2020.vue